import { AppDispatch, Store } from 'store';
import { AppBundle } from 'api/optimalprint-sdk.d';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmCategoryViewItemListEvent from 'utils/gtm/gtmCategoryViewItemListEvent';
import fetchGTMProductsDataForCurrentDesignsOperation from './fetchGTMProductsDataForCurrentDesignsOperation';
import getGtmProductsData from '../selector/getGtmProductsData';

const sendGtmViewItemListOperation =
  (designs: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Family.IDesign[]) =>
  async (dispatch: AppDispatch, getState: () => Store) => {
    const designIds = designs.map((design) => design.designIdEncrypted);
    await dispatch(fetchGTMProductsDataForCurrentDesignsOperation());
    const store = getState();
    const gtmProductsData = getGtmProductsData(store);
    if (gtmProductsData.length && designIds.length) {
      gtmSendEvent(gtmCategoryViewItemListEvent(gtmProductsData, designIds));
    }
  };

export default sendGtmViewItemListOperation;
